<div [ngSwitch]="action" class="header">
  <h2 *ngSwitchCase="'inspection-general'">Gestione <strong>Ispezioni</strong></h2>
  <h2 *ngSwitchCase="'schedule'"><strong>Programmazione</strong></h2>
  <h2 *ngSwitchCase="'inspection'"><strong>Ispezione</strong></h2>
  <div class="breadcrumb-wrapper hidden-xs">
    <ol class="breadcrumb">
      <li *ngSwitchCase="'inspection-general'" class="active">Gestione Ispezioni</li>
      <li *ngSwitchCase="'schedule'" class="active">Programmazione</li>
      <li *ngSwitchCase="'inspection'" class="active">Ispezione</li>
    </ol>
  </div>
</div>
<div class="row" *ngIf="user.fk_id_role <= 2">
  <div class="col-lg-12 portlets">
    <div class="panel">
      <div class="panel-header panel-controls bg-dark">
        <h3><i class="fa fa-search"></i> Ricerca <strong>Ispezioni</strong></h3>
      </div>
      <form (ngSubmit)="goToSearch()" #searchInspectionsForm="ngForm" role="form" class="form-horizontal form-validation">
        <div class="panel-content">
          <div class="row">
            <div class="col-md-12 col-12">

                <div class="col-sm-6 col-12" style="margin-bottom: 20px;">
                  <label for="status" class="col-sm-2 control-label">Status</label>
                  <div class="col-sm-9">
                    <select class="form-control"
                            name="status"
                            id="status"
                            style="width:100%;"
                            required
                            [(ngModel)]="inspectionSearchParams.fk_id_inspection_state">
                      <option [ngValue]="" disabled selected>Seleziona Status...</option>
                      <option *ngFor="let inspectionState of inspectionStates"
                              [ngValue]="inspectionState.id_inspection_state">{{ inspectionState.value }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-6 col-12" style="margin-bottom: 20px;">
                  <label for="contract" class="col-sm-2 control-label">Convenzione</label>
                  <div class="col-sm-9">
                    <select class="form-control"
                            name="contract"
                            id="contract"
                            style="width:100%;"
                            required
                            [(ngModel)]="inspectionSearchParams.fk_id_contract">
                      <option [ngValue]="" disabled selected>Seleziona Convenzione...</option>
                      <option *ngFor="let contract of contracts"
                              [ngValue]="contract.id_contract">{{ contract.name }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-6 col-12" style="margin-bottom: 20px;">
                  <label for="pa" class="col-sm-2 control-label">PA</label>
                  <div class="col-sm-9">
                    <select class="form-control"
                            name="pa"
                            id="pa"
                            style="width:100%;"
                            required
                            [(ngModel)]="inspectionSearchParams.fk_id_pa">
                      <option [ngValue]="" disabled selected>Seleziona PA...</option>
                      <option *ngFor="let pa of pas"
                              [ngValue]="pa.id_pa">{{ pa.name }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-6 col-12" style="margin-bottom: 20px;">
                  <label for="inspector" class="col-sm-2 control-label">Ispettore</label>
                  <div class="col-sm-9">
                    <select class="form-control"
                            name="inspector"
                            id="inspector"
                            style="width:100%;"
                            required
                            [(ngModel)]="inspectionSearchParams.fk_id_user">
                      <option [ngValue]="" disabled selected>Seleziona Ispettore...</option>
                      <option *ngFor="let user of users"
                              [ngValue]="user.id_user">{{ user.name + ' ' + user.surname }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-6 col-12">
                  <label for="contract-founder" class="col-sm-2 control-label">Fornitore</label>
                  <div class="col-sm-9">
                    <select class="form-control"
                            name="contract-founder"
                            id="contract-founder"
                            style="width:100%;"
                            required
                            [(ngModel)]="inspectionSearchParams.fk_id_contract_founder">
                      <option [ngValue]="" disabled selected>Seleziona Fornitore...</option>
                      <option *ngFor="let contractFounder of contractFounders"
                              [ngValue]="contractFounder.id_contract_founder">{{ contractFounder.name }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-6 col-12" style="margin-bottom: 20px;">
                  <label class="col-sm-3 control-label">Operatore Logico</label>
                  <mat-radio-group id="operator"
                                   name="operator"
                                   [(ngModel)]="inspectionSearchParams.operator">
                    <mat-radio-button value="and">AND</mat-radio-button>
                    <mat-radio-button value="or">OR</mat-radio-button>
                  </mat-radio-group>
                </div>

            </div>
          </div>
        </div>
        <div class="panel-footer">
          <button type="submit" class="btn btn-danger"><i class="fa fa-search"></i>&nbsp;Avvia Ricerca</button>
          <button type="button" class="btn btn-default" (click)="resetSearch()"><i class="fa fa-eraser"></i>&nbsp;Reset</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-lg-12 portlets">
    <div class="panel">
      <div class="panel-header panel-controls bg-dark">
        <h3><i class="fa fa-table"></i> Lista <strong>Ispezioni</strong></h3>
      </div>
      <div class="panel-content">
        <div class="row">
          <div class="col-md-1 col-4" style="padding-top: 5px;">
            <label for="items-per-page">Mostra</label>
          </div>
          <div class="col-md-1 col-4">
            <div class="form-group">
              <input [(ngModel)]="paginationConfig.itemsPerPage" (change)="paginationConfig.currentPage = 1"
                     class="form-control input-sm form-white"
                     id="items-per-page" name="items-per-page" type="number">
            </div>
          </div>
          <div class="col-md-1 col-4" style="padding-top: 5px;">
            <label for="items-per-page">{{ paginationConfig.itemsPerPage > 1 ? 'risultati' : 'risultato' }}</label>
          </div>
          <div *ngIf="user.fk_id_role === 3"
               class="col-md-8 col-md-offset-1"
               style="text-align: right;">
            <button type="button"
                    class="btn"
                    [ngClass]="inspectionView === 'all' ? 'btn-primary' : 'btn-default'"
                    (click)="inspectionView = 'all'">Tutte</button>
            <button type="button"
                    class="btn"
                    [ngClass]="inspectionView === 'toDo' ? 'btn-primary' : 'btn-default'"
                    (click)="inspectionView = 'toDo'">Da fare</button>
            <button type="button"
                    class="btn"
                    [ngClass]="inspectionView === 'done' ? 'btn-primary' : 'btn-default'"
                    (click)="inspectionView = 'done'">Eseguita</button>
            <button type="button"
                    class="btn"
                    [ngClass]="inspectionView === 'checked' ? 'btn-primary' : 'btn-default'"
                    (click)="inspectionView = 'checked'">Validata</button>
          </div>
        </div>
        <div class="table-responsive" style="padding-bottom: 70px;">
          <table class="table table-hover">
            <thead>
            <tr>
              <th style="width: 10%;">Status</th>
              <th style="width: 20%;">Convenzione</th>
              <th style="width: 10%;">Ispettore</th>
              <th style="width: 10%;">Data Ispezione</th>
              <th *ngIf="action === 'inspection'" style="width: 10%;">Data Validazione</th>
              <th style="width: 20%;">PA</th>
              <th style="width: 15%;">Comune</th>
              <th style="width: 5%;">Provincia</th>
              <th class="text-right" style="width: 10%;">Azioni</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let inspection of inspections |
                  inspectionInspectorFilter: inspectionView : user |
                  paginate: paginationConfig">
              <td><i *ngIf="reservationsByInspection[inspection.id_inspection] && user.fk_id_role <= 2 &&
                inspection.inspection_state?.id_inspection_state === 1" class="fa fa-users"></i>{{ inspection.inspection_state?.value }}</td>
              <td>{{ inspection.contract.name }}</td>
              <td>{{ (inspection.user ) ? (inspection.user?.name + ' ' + inspection.user?.surname) : '' }}</td>
              <td>{{ inspection.date | date: 'dd/MM/yyyy HH:mm' }}</td>
              <td *ngIf="action === 'inspection'">{{ inspection.date_validation | date: 'dd/MM/yyyy HH:mm' }}</td>
              <td>{{ inspection.pa.name }}</td>
              <td>{{ inspection.pa.municipality }}</td>
              <td>{{ inspection.pa.province }}</td>
              <td class="text-right">
                <div class="btn-group">
                  <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Azioni</button>
                  <ul [ngSwitch]="action" class="dropdown-menu dropdown-menu-right">
                    <li *ngSwitchCase="'inspection-general'"><a [routerLink]="['/inspection/' + inspection.id_inspection]">
                      <i class="fa fa-info-circle"></i>&nbsp;Dettaglio Ispezione
                    </a></li>
                    <li *ngSwitchCase="'inspection'"><a *ngIf="(user.fk_id_role <= 1 || (user.fk_id_role === 3 &&
                            inspection.fk_id_user === user.id_user)) &&
                            inspection.inspection_state?.id_inspection_state === 4"
                           [routerLink]="['/inspection/checklist/' + inspection.id_inspection]">
                      <i class="fa fa-pencil"></i>&nbsp;Inserisci
                    </a></li>
                    <li *ngSwitchCase="'inspection'"><a *ngIf="(user.fk_id_role <= 1 || (user.fk_id_role === 3 &&
                            inspection.fk_id_user === user.id_user)) &&
                            inspection.inspection_state?.id_inspection_state === 5"
                           [routerLink]="['/inspection/checklist/' + inspection.id_inspection]">
                      <i class="fa fa-pencil"></i>&nbsp;Modifica
                    </a></li>
                    <li *ngSwitchCase="'inspection'"><a *ngIf="user.fk_id_role <= 4 &&
                            inspection.inspection_state?.id_inspection_state === 6"
                            [routerLink]="['/inspection/checklist/' + inspection.id_inspection]">
                      <i class="fa fa-file-text-o"></i>&nbsp;Visualizza Rapporto
                    </a></li>
                    <li *ngSwitchCase="'inspection'"><a *ngIf="user.fk_id_role <= 1 &&
                            inspection.inspection_state?.id_inspection_state === 5"
                            (click)="openValidateInspectionModal(inspection)"
                            style="cursor: pointer;">
                      <i class="fa fa-check-square"></i>&nbsp;Valida
                    </a></li>
                    <li *ngSwitchCase="'inspection'"><a *ngIf="user.fk_id_role <= 1 &&
                            inspection.inspection_state?.id_inspection_state === 6"
                            (click)="openDeleteValidationInspectionModal(inspection)"
                            style="cursor: pointer;">
                      <i class="fa fa-backward"></i>&nbsp;Annulla Valida
                    </a></li>
                    <li><a *ngIf="user.fk_id_role === 3 &&
                            !userReservations[inspection.id_inspection!] &&
                            inspection.fk_id_user !== user.id_user &&
                            inspection.inspection_state?.id_inspection_state === 1"
                           (click)="openCreateReservationModal(inspection)"
                           style="cursor: pointer;">
                      <i class="icons-office-01"></i>&nbsp;Prenota
                    </a></li>
                    <li><a *ngIf="user.fk_id_role === 3 &&
                            userReservations[inspection.id_inspection!] &&
                            inspection.inspection_state?.id_inspection_state === 1"
                           (click)="openDeleteReservationModal(inspection)"
                           style="cursor: pointer;">
                      <i class="icons-office-46"></i>&nbsp;Annulla Prenotazione
                    </a></li>
                    <li *ngSwitchCase="'schedule'"><a *ngIf="user.fk_id_role <= 2 &&
                            !inspection.user &&
                            inspection.inspection_state?.id_inspection_state === 1"
                           (click)="openViewReservationModal(inspection)"
                           style="cursor: pointer;">
                      <i class="icons-office-02"></i>&nbsp;Vedi Prenotazioni
                    </a></li>

                    <li *ngSwitchCase="'schedule'"><a *ngIf="user.fk_id_role <= 2 &&
                            !inspection.user &&
                            inspection.inspection_state?.id_inspection_state === 1"
                           (click)="openAssignInspectionModal(inspection)"
                           style="cursor: pointer;">
                      <i class="icons-office-01"></i>&nbsp;Assegna
                    </a></li>
                    <li *ngSwitchCase="'schedule'"><a *ngIf="user.fk_id_role <= 2 &&
                            ( inspection.inspection_state?.id_inspection_state === 2 ||
                                inspection.inspection_state?.id_inspection_state === 3 )"
                           (click)="openPlanInspectionModal(inspection)"
                           style="cursor: pointer;">
                      <i class="icons-office-24"></i>&nbsp;{{ (inspection.inspection_state?.id_inspection_state === 2) ? 'Pianifica' : 'Modifica Data' }}
                    </a></li>
                    <li *ngSwitchCase="'schedule'"><a *ngIf="user.fk_id_role <= 2 &&
                            inspection.inspection_state?.id_inspection_state === 3"
                           (click)="openRegisterInspectionModal(inspection)"
                           style="cursor: pointer;">
                      <i class="fa fa-check"></i>&nbsp;Registra
                    </a></li>
                    <li><a *ngIf="user.fk_id_role <= 2 && inspection.inspection_state?.id_inspection_state !== 6"
                           (click)="openResetInspectionModal(inspection)"
                           style="cursor: pointer;">
                      <i class="fa fa-eraser"></i>&nbsp;{{ (action === 'inspection' && user.fk_id_role === 2) ? 'Rendi Non Prenotata' : 'Reset' }}
                    </a></li>
                    <li *ngSwitchCase="'inspection-general'"><a *ngIf="user.fk_id_role <= 1"
                           (click)="openDeleteInspectionModal(inspection)"
                           style="cursor: pointer;">
                      <i class="icons-office-57"></i>&nbsp;Elimina
                    </a></li>
                  </ul>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
          <div *ngIf="(inspections | inspectionInspectorFilter: inspectionView : user).length === 0"
               style="text-align: center; padding: 50px 0;"><h4>Nessun risultato</h4></div>
        </div>
        <pagination-controls [maxSize]="paginationParams.maxSize"
                             [autoHide]="paginationParams.autoHide"
                             [responsive]="paginationParams.responsive"
                             [previousLabel]="paginationLabels.previousLabel"
                             [nextLabel]="paginationLabels.nextLabel"
                             [screenReaderPaginationLabel]="paginationLabels.screenReaderPaginationLabel"
                             [screenReaderPageLabel]="paginationLabels.screenReaderPageLabel"
                             [screenReaderCurrentLabel]="paginationLabels.screenReaderCurrentLabel"
                             (pageChange)="onPageChange($event)"
                             (pageBoundsCorrection)="onPageBoundsCorrection($event)"
        ></pagination-controls>
      </div>
    </div>
  </div>
</div>
